export const TOKEN_ACTIONS = {
    employeeBankAccountUpdate: {
        label: 'Modificar cuenta bancaria empleado',
        slug: 'EMPLEADO_MODIFICAR_CUENTA_BANCARIA',
    },
};

export const TOKEN_STATUSES = {
    pending: {
        color: 'primary',
        label: 'Pendiente',
        slug: 'PENDIENTE',
    },
    approved: {
        color:'success',
        label: 'Aprobado',
        slug: 'APROBADO',
    },
    rejected: {
        color: 'danger',
        label: 'Rechazado',
        slug: 'RECHAZADO',
    },
    used: {
        color:'success',
        label: 'Usado',
        slug: 'USADO',
    },
    expired: {
        color: 'warning',
        label: 'Expirado',
        slug: 'EXPIRADO',
    },
    cancelled: {
        color: 'danger',
        label: 'Cancelado',
        slug: 'CANCELADO',
    },
};